
import { initializeStep4 } from '../config-step-4/config-step-4.js'; 
import gustibusConfigData from '../config-data.js';

export function initializeStep3() {

    const selectedData = window.mergedData;
    const formatElements = document.querySelectorAll('.format-elements .format-element');
    const coverElements = document.querySelectorAll('.cover-elements .cover-element');
    const nextBtnThirdStep = document.querySelector('.third-step-wrapper .next-btn');

    const ingredientsWithName = document.querySelector('.fourth-step-private .product-dsp .ingredients .ingredient_with').textContent;
    const recipesWithName = document.querySelector('.fourth-step-gustibus .product-dsp .ingredients .ingredient_with').textContent;
    const mobileResultsWithName = document.querySelectorAll('.result-product-mobile .ingredients .ingredient_with');
    const fifthStepResults = document.querySelectorAll('.fifth-step-wrapper .desktop-product-result .ingredients .ingredient_with');

    if (selectedData.selectedBrand == 'gustibus') {
        mobileResultsWithName.forEach((el) => {
            el.innerHTML = recipesWithName;
        });
        fifthStepResults.forEach((el) => {
            el.innerHTML = recipesWithName;
        });
    } else if (selectedData.selectedBrand == 'private') {
        mobileResultsWithName.forEach((el) => {
            el.innerHTML = ingredientsWithName;
        });
        fifthStepResults.forEach((el) => {
            el.innerHTML = ingredientsWithName;
        });
    }

    document.getElementById('config-step-4').classList.remove('disabled');
    document.querySelector('[data-tab-target="#config-step-4"]').classList.remove('disabled');
    document.querySelector('[data-tab-target="#config-step-4"]').classList.remove('filled');

    function checkSelectionsStepThree() {
        var isValid = false;
        if(document.querySelectorAll('.format-elements .format-element.active').length > 0 && document.querySelectorAll('.cover-elements .cover-element.active').length > 0) {
            isValid = true;
        } else {
            isValid = false;
        }
        
        if(isValid) {
            nextBtnThirdStep.classList.remove('disabled');
        } else {
            nextBtnThirdStep.classList.add('disabled');
        }
    }

    function getCustomPackage() {
        let customPackage = [];
        if(selectedData.selectedSubcategory || selectedData.selectedSubcategory != null) {
            customPackage = gustibusConfigData.categories[selectedData.selectedCategory].subcategories[selectedData.selectedSubcategory].custom_package;
        }
        return customPackage;
    }

    function handleCustomPackage() {
        const packages = getCustomPackage();
        const coverContainer = document.querySelector('.cover-elements');
        const customCover = document.querySelectorAll('.cover-element.is_custom');

        if(packages.length > 0) {
            coverContainer.classList.add('has_custom');
            if(customCover) {
                customCover.forEach((el) => {
                    el.remove();
                });
            }
            coverElements.forEach((el) => {
                el.classList.remove('active');
                el.classList.add('hide');
            });
            
            packages.forEach((cover, index) => {
                const coverElement = createCustomCoverElement(cover, index);
                coverContainer.appendChild(coverElement);
            });
        } else {
            coverContainer.classList.remove('has_custom');
            coverElements.forEach((el) => {
                el.classList.remove('hide');
            });
            if(customCover) {
                customCover.forEach((el) => {
                    el.remove();
                });
            }
        }
    }
    
    function createCustomCoverElement(cover, index) {
        const coverElement = document.createElement('div');
        coverElement.setAttribute('data-index', index);
        coverElement.classList.add('cover-element', 'is_custom');


        const pictureElement = document.createElement('picture');
        pictureElement.classList.add('img');

        const imgElement = document.createElement('img');
        imgElement.setAttribute('src', cover.image);
        imgElement.setAttribute('data-src', cover.image);
        imgElement.setAttribute('alt', 'Packaging icon');
        pictureElement.appendChild(imgElement);

        const activePictureElement = document.createElement('picture');
        activePictureElement.classList.add('active-img');

        const activeImgElement = document.createElement('img');
        activeImgElement.setAttribute('src', cover.activeImage);
        activeImgElement.setAttribute('data-src', cover.image);
        activeImgElement.setAttribute('alt', 'Packaging icon');

        activePictureElement.appendChild(activeImgElement);

        const coverTitleElement = document.createElement('p');
        coverTitleElement.classList.add('cover-name');
        coverTitleElement.textContent = cover.title;


        coverElement.appendChild(pictureElement);
        coverElement.appendChild(activePictureElement);
        coverElement.appendChild(coverTitleElement);

        coverElement.addEventListener('click', () => {
            document.querySelectorAll('.cover-elements .cover-element').forEach(sub => {
                sub.classList.remove('active');
            });
            coverElement.classList.add('active');
            checkSelectionsStepThree();
        });

        return coverElement;
    }

    const formatsContainer = document.querySelector('.format-elements');
    formatsContainer.innerHTML = '';

    function createFormatElement(format, index) {
        const images = format.images;
        const formatElement = document.createElement('div');
        formatElement.setAttribute('data-index', index);
        formatElement.setAttribute('data-id', format.id);
        formatElement.classList.add('format-element');
        formatElement.style.order = format.order;

        if(images) {
            images.forEach(image => {
                const pictureElement = document.createElement('picture');
                pictureElement.classList.add(image.class);


                const sourceElement = document.createElement('source');
                sourceElement.setAttribute('srcset', image.url);
                sourceElement.setAttribute('data-srcset', image.url);
                sourceElement.setAttribute('type', 'image/webp');

                const imgElement = document.createElement('img');
                imgElement.setAttribute('src', image.url);
                imgElement.setAttribute('data-src', image.url);
                imgElement.setAttribute('alt', image.alt);

                pictureElement.appendChild(sourceElement);
                pictureElement.appendChild(imgElement);

                formatElement.appendChild(pictureElement);
            })
        }
        
        const formatTitleElement = document.createElement('p');
        formatTitleElement.classList.add('format-name');
        formatTitleElement.textContent = format.title;
        
        const formatSubtitleElement = document.createElement('p');
        formatSubtitleElement.classList.add('format-dsp');
        formatSubtitleElement.textContent = format.subtitle + " " + format.weight + "g";

        formatElement.appendChild(formatTitleElement);
        formatElement.appendChild(formatSubtitleElement);

        formatElement.addEventListener('click', () => {
            const formatElements = document.querySelectorAll('.format-element');
            formatElements.forEach(sub => {
                sub.classList.remove('active');
            });
            formatElement.classList.add('active');
            checkSelectionsStepThree();
        });

        return formatElement;
    }

    function getFormats() {
        let data = {};
        if(selectedData.selectedGroup || selectedData.selectedGroup != null ) {
            data = gustibusConfigData.categories[selectedData.selectedCategory].subcategories[selectedData.selectedSubcategory].groups[selectedData.selectedGroup].formats[selectedData.selectedBrand];
        } else if(selectedData.selectedSubcategory || selectedData.selectedSubcategory != null) {
            data = gustibusConfigData.categories[selectedData.selectedCategory].subcategories[selectedData.selectedSubcategory].formats[selectedData.selectedBrand];
        } else if(selectedData.selectedCategory || selectedData.selectedCategory != null) {
            data = gustibusConfigData.categories[selectedData.selectedCategory].formats[selectedData.selectedBrand];
        }

        return data;
    }

    function updateSelectedData() {
        const formatElements = document.querySelectorAll('.format-elements .format-element');
        const coverElements = document.querySelectorAll('.cover-elements .cover-element');

        formatElements.forEach(formatelement => {
            if (formatelement.classList.contains('active')) {
                const formatNameFull = formatelement.querySelector('.format-name').textContent.trim();
                const formatDescription = formatelement.querySelector('.format-dsp').textContent.trim();
                const formatID = formatelement.getAttribute('data-id');
                const formatImg = formatelement.querySelector('.img img').getAttribute('data-src');

                window.mergedData = {
                    ...window.mergedData,
                    selectedFormat: {
                        id: formatID,
                        name: formatNameFull,
                        description: formatDescription,
                        img: formatImg
                    }
                };
            }
        });

        coverElements.forEach(coverelement => {
            if (coverelement.classList.contains('active')) {
                const coverName = coverelement.querySelector('.cover-name').textContent.trim();

                window.mergedData.selectedCover = coverName;
            }
        });
    }

    const formats = getFormats();
    const formatsIDs = Object.keys(getFormats());

    formatsIDs.forEach((formatID, index) => {
        const formatElement = createFormatElement(formats[formatID], index);
        formatsContainer.appendChild(formatElement);
    });

    nextBtnThirdStep.addEventListener('click', function() {
        if(!this.classList.contains('disabled')) {
            updateSelectedData();
            initializeStep4();
        }

    });

    // formatElements.forEach(formatelement => {
    //     formatelement.addEventListener('click', () => {
    //         formatElements.forEach(sub => {
    //             sub.classList.remove('active');
    //         });
    //         formatelement.classList.add('active');
    //     });
    // });

    coverElements.forEach(coverelement => {
        if(!coverelement.classList.contains('is_custom')) {
            coverelement.addEventListener('click', () => {
                document.querySelectorAll('.cover-elements .cover-element').forEach(sub => {
                    sub.classList.remove('active');
                });
                coverelement.classList.add('active');
            });
        }
    });

    function setFirstAsActive(elements) {
        elements.forEach((el) => {
            el.classList.remove('active')
        });
        elements[0].classList.add('active');
    }
    setFirstAsActive(document.querySelectorAll('.format-elements .format-element'));
    setFirstAsActive(document.querySelectorAll('.cover-elements .cover-element'));

    checkSelectionsStepThree();
    handleCustomPackage();

    if(document.querySelector('.cover-elements.has_custom')) {
        setFirstAsActive(document.querySelectorAll('.has_custom .is_custom'));
    }
}
